import * as Yup from "yup";
import MESSAGE from "~/utils/messages";

export const schema = Yup.object().shape({
  Nome: Yup.string()
    .matches(
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]+(?: [a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð'-]+)+$/u,
      MESSAGE.invalidName
    )
    .required(MESSAGE.requiredField),
  Email: Yup.string()
    .email(MESSAGE.invalidMail)
    .required(MESSAGE.requiredField),
  ConfirmaEmail: Yup.string()
    .email(MESSAGE.invalidMail)
    .required(MESSAGE.mismatchedMail)
    .test("ConfirmaEmail", MESSAGE.mismatchedMail, function() {
      const email = this.parent.Email?.toUpperCase();
      const confirmEmail = this.parent.ConfirmaEmail?.toUpperCase();
      return !(email !== confirmEmail);
    }),
  Senha: Yup.string()
    .required(MESSAGE.requiredField)
    .min(8, MESSAGE.passwordMatch)
    .max(32, MESSAGE.passwordMatch)
    .test({
      name: "newPasswordNumber",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[0-9]/.test(value), // Simplificado
    })
    .test({
      name: "newPasswordString",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[a-zA-Z]/.test(value), // Simplificado
    })
    .test({
      name: "newPasswordSpecialCharacter",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[^a-zA-Z0-9]/.test(value), // Simplificado
    }),
  ConfirmaSenha: Yup.string()
    .required(MESSAGE.requiredField)
    .oneOf([Yup.ref("Senha"), null], MESSAGE.mismatchedPass),
});